var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.063c-2.399 0-4.67-1.017-6.394-2.863a.563.563 0 01.823-.767C4.938 12.048 6.916 12.938 9 12.938c2.68 0 5.146-1.466 6.66-3.938C14.147 6.528 11.68 5.062 9 5.062c-2.778 0-5.328 1.576-6.823 4.215a.562.562 0 11-.979-.554C2.895 5.726 5.812 3.937 9 3.937c3.188 0 6.105 1.79 7.802 4.786a.562.562 0 010 .554c-1.697 2.996-4.614 4.786-7.802 4.786z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.813A2.816 2.816 0 016.187 9 2.816 2.816 0 019 6.187 2.816 2.816 0 0111.813 9 2.816 2.816 0 019 11.813zm0-4.5A1.69 1.69 0 007.312 9c0 .93.758 1.688 1.688 1.688A1.69 1.69 0 0010.688 9 1.69 1.69 0 009 7.312z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/eyeIcon.d0c09cc8.svg";
export { MemoForwardRef as ReactComponent };